import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=5f779f50&scoped=true&"
import script from "./Tasks.ts?vue&type=script&lang=ts&"
export * from "./Tasks.ts?vue&type=script&lang=ts&"
import style0 from "./Tasks.scss?vue&type=style&index=0&id=5f779f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f779f50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCardText,VContainer,VForm,VProgressCircular})
